<template>
  <div class="support" :style="{ 'min-height': clientHeight + 'px' }">
    <div class="loading" v-if="load" :style="{ 'min-height': '2007px' }"></div>
    <div class="support-header">
      <div class="header-content">
        <span class="nav-title">你需要什么帮助？</span>

        <div class="search">
          <span class="search-icon"> </span>
          <span class="support-input">
            <input type="text" class="support-ipt" placeholder="描述你的问题" v-model="searchinpt"
              @keydown.enter="search()" /></span>
        </div>
      </div>
    </div>
    <div class="support-content">
      <div class="content-title">
        <span>浏览帮助主题</span>
      </div>
      <article class="support-main">
        <dl class="support-list" v-for="(item, index) in faqList" :key="index">
          <dt class="support-title">
            <a :href="'#' + item.EnName.replaceAll(` `, `-`)" @click="lineOpen(item.EnName)">{{ item.ulName }}
            </a>
            <span class="arrow" :class="{ active: titleActive == item.EnName ? true : false }"></span>
          </dt>
          <div class="item-overflow" :style="{ 'margin-top': -52 * item.faqListUl.length + 'px' }"
            :class="{ active: titleActive == item.EnName ? true : false }">
            <dd class="support-item" v-for="(items, index) in item.faqListUl" :key="index">
              <a @click="getTitle(items.value)">{{ items.value }}</a>
            </dd>
          </div>
        </dl>
      </article>

      <Freq></Freq>
    </div>
    <div class="support-bottom-nav" v-if="!load">
      <div class="sbn-title">
        <div class="title">需要更多帮助？</div>
        <div class="underline">尝试这些步骤:</div>
      </div>
      <div class="sbn-container">
        <div class="tabs">
          <div class="tabs-container">
            <div class="title">加入论坛/Reddit</div>
            <div class="underline">
              问问题，找答案，获取更新通知，分享你的体验。
            </div>
            <a class="btn" href="https://forum.skybox.xyz/"> 加入论坛</a>
            <a class="btn" href="https://www.reddit.com/r/SKYBOXVR/">
              加入 Reddit</a>
          </div>
        </div>
        <div class="tabs">
          <div class="tabs-container">
            <div class="title">联系我们</div>
            <div class="underline">
              详细描述问题，联系支持中心，我们将帮你解决问题。
            </div>
            <a class="btn" href="/submit-a-ticket-zh">点击反馈</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import i18n from "../lang";
import Freq from "../components/Freq.vue";

export default {
  components: { Freq },
  setup() {
    useRouter().currentRoute.value.query == "1";
    return;
  },
  data() {
    return {
      clientHeight: document.documentElement.clientHeight - 104,
      searchinpt: "",
      fullWidth: document.documentElement.clientWidth,

      Frequently: "",
      load: true,
      faqList: [],
      titleActive: "",
    };
  },
  watch: {

  },
  created() {
    this.load = true;
    this.getFaqList();

    i18n.global.locale = "zh";
    zE("webWidget", "show"); //进到页面就启动组件
    zE("webWidget", "setLocale", "zh-CN"); //设置语言

    window.zESettings = {
      webWidget: {
        color: { theme: "#fed65d" },
        offset: { horizontal: "25px", vertical: "25px" },
        contactForm: {
          attachments: true,
          ticketForms: [
            {
              id: 1500003115541,
              title: false,
              subject: false,
              fields: [
                {
                  id: "description",
                  labels: {
                    "*": "测试",
                  },
                  hint: {
                    "zh-CN":
                      "如在使用中遇到任何问题，请描述问题本身和如何遇到问题的。如想要 SKYBOX 支持新的功能，请描述你的需求和使用场景。",
                  },
                  prefill: { "*": " " },
                },
              ],
            },
          ],
        },
      },
    };
  },
  mounted() {
    if (this.fullWidth > 767) {
      document.querySelector(".supportLi").style.color = "#fff";
    }
  },
  methods: {
    getTitle(title) {
      var obj = this.$route.params.title;
      axios({
        url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
        method: "POST",
        data: {
          methods: "getLangkeys",
          title: title,
        },
      }).then((result) => {
        this.$router.push(
          "/support-zh/" +
          result.data.Items[0].langkeys
            .replaceAll(` `, `-`)
            .replaceAll(`/`, `&`) +
          "/"
        );
      });
    },
    lineOpen(title) {
      console.log(this.titleActive);
      if (title == this.titleActive) {
        this.titleActive = "";
      } else {
        this.titleActive = title;
      }
    },

    async getFaqList() {
      await this.$http({
        url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
        method: "POST",
        data: {
          methods: "getFaqList",
          Id: "zhFaqList",
        },
      })
        .then((res) => {

          this.$http({
            url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
            method: "POST",
            data: {
              methods: "getFaqList",
              Id: "enFaqList",
            },
          }).then((result) => {
            this.load = false;
            this.faqList = res.data.Item.faqList;
            console.log(this.faqList);
            this.faqList.map((item, index) => {

              item.EnName = result.data.Item.faqList[index].ulName
            });
            if (this.$route.hash.split("#")[1]) {
              this.titleActive = this.$route.hash
                .split("#")[1]
                .replaceAll(`-`, ` `);
            } else {
              this.titleActive = this.faqList[0].EnName;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search() {
      if (this.$i18n.t("m.lang") == "en") {
        if (this.searchinpt != "") {
          this.$router.push({
            path: "/search",
            query: { search: this.searchinpt },
          });
        }
      } else {
        if (this.searchinpt != "") {
          this.$router.push({
            path: "/search-zh",
            query: { search: this.searchinpt },
          });
        }
      }
    },
    goZh(tp) {
      this.$router.push({
        path: tp,
        query: { lang: "zh" },
      });
    },
    goContent(value) {
      this.$router.push({
        path: "/content",
        query: { title: value, lang: "zh" },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/support.scss";
</style>